import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer165 } from './pages'

type TIdToPageMapWoofzOffer165 = Record<PageIdWoofzOffer165, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER1_65: TIdToPageMapWoofzOffer165 = {
  [PageIdWoofzOffer165.SUBSCRIPTIONS_OFFER1_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/subscriptions/SubscriptionsOffer165'
      ).then((m) => ({
        default: m.SubscriptionsOffer165,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/subscriptions/SubscriptionsOffer165'
      ),
  },
  [PageIdWoofzOffer165.CHAT_UPSELL_OFFER1_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer165.UPSELL_OFFER1_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer1_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer165.DOWNLOAD_OFFER1_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer165.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
